import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface NotificationTemplate {
  id: string;
  name: string;
  notificationType: string;
  channel: string;
  subjectTemplate: string | null;
  htmlBodyTemplate: string | null;
  textBodyTemplate: string | null;
  variables: Record<string, unknown> | null;
  version: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationTemplatesResponse {
  data: NotificationTemplate[];
  meta: {
    nextCursor: string | null;
  };
}

const _mockData: NotificationTemplatesResponse = {
  data: [],
  meta: {
    nextCursor: null,
  },
};

const getNotificationTemplates: QueryFunction<
  NotificationTemplatesResponse,
  ['/admin/notification-templates']
> = async () => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const response = await authTokenHttp<NotificationTemplatesResponse>(
    `/notification-templates`,
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data;

  throw new Error('Failed to fetch notification templates');
};

export default getNotificationTemplates;
